module.exports = __webpack_public_path__ + "static/alloversheepbath-5842ae82c4222c90a6729f63ea7be552.jpeg";